import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAdminAuthStore } from '../stores/authStore';
import { FaSignOutAlt, FaChartLine, FaUsers, FaVideo, FaFilm, FaCog } from 'react-icons/fa';

export default function AdminNavbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const admin = useAdminAuthStore((state) => state.admin);
  const logout = useAdminAuthStore((state) => state.logout);

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="bg-gray-900 text-white shadow-lg">
      <div className="max-w-7xl mx-auto px-4 py-4">
        <div className="flex justify-between items-center">
          {/* Logo & Brand */}
          <div className="flex items-center gap-8">
            <h1 className="text-2xl font-bold">vSkul Admin</h1>
            
            {/* Navigation Links */}
            <div className="flex items-center gap-4">
              <button
                onClick={() => navigate('/dashboard')}
                className={`flex items-center gap-2 px-3 py-2 rounded-lg transition ${
                  isActive('/dashboard')
                    ? 'bg-blue-600'
                    : 'hover:bg-gray-800'
                }`}
              >
                <FaChartLine size={18} />
                Dashboard
              </button>

              <button
                onClick={() => navigate('/users')}
                className={`flex items-center gap-2 px-3 py-2 rounded-lg transition ${
                  isActive('/users')
                    ? 'bg-blue-600'
                    : 'hover:bg-gray-800'
                }`}
              >
                <FaUsers size={18} />
                Users
              </button>

              <button
                onClick={() => navigate('/rooms')}
                className={`flex items-center gap-2 px-3 py-2 rounded-lg transition ${
                  isActive('/rooms')
                    ? 'bg-blue-600'
                    : 'hover:bg-gray-800'
                }`}
              >
                <FaVideo size={18} />
                Rooms
              </button>

              <button
                onClick={() => navigate('/recordings')}
                className={`flex items-center gap-2 px-3 py-2 rounded-lg transition ${
                  isActive('/recordings')
                    ? 'bg-blue-600'
                    : 'hover:bg-gray-800'
                }`}
              >
                <FaFilm size={18} />
                Recordings
              </button>

              <button
                onClick={() => navigate('/settings')}
                className={`flex items-center gap-2 px-3 py-2 rounded-lg transition ${
                  isActive('/settings')
                    ? 'bg-blue-600'
                    : 'hover:bg-gray-800'
                }`}
              >
                <FaCog size={18} />
                Settings
              </button>
            </div>
          </div>

          {/* User Info & Logout */}
          <div className="flex items-center gap-4">
            <span className="text-sm text-gray-300">{admin?.full_name || admin?.email}</span>
            <button
              onClick={handleLogout}
              className="flex items-center gap-2 px-3 py-2 text-red-400 hover:bg-gray-800 rounded-lg transition"
              title="Logout"
            >
              <FaSignOutAlt size={18} />
              Logout
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}